import keyMirror from 'keymirror';

const FARE_SEARCH_STATUS = keyMirror({
  UNAVAILABLE: null,
  SOLDOUT: null,
  AVAILABLE: null,
});

export default FARE_SEARCH_STATUS;
